
if (!customElements.get('honor-list-v3')) {
  class WhyChoose extends HTMLElement {
    constructor() {
      super();
      // const isMobile = `(max-width: 768px)`;
      // const isMobileMQL = window.matchMedia(isMobile);

      // isMobileMQL.addEventListener('change', (event) => {
      //   if (this.mySwiper) this.destroySwiper();
      //   if (event.matches) {
      this.createMobileSlider();
      //   }
      // });
      // if (isMobileMQL.matches) this.createMobileSlider();
    }

    createMobileSlider() {
      // Replace Swiper with CSS keyframe marquee for truly continuous, seamless scrolling
      const container = this.querySelector('.swiper-container');
      if (!container) return;

      const originalList = container.querySelector('.honor-list-v3__icon-list');
      if (!originalList) return;

      // Build marquee track: listA + listB (clone) for seamless loop
      const track = document.createElement('div');
      track.className = 'honor-marquee-track';

      const listA = originalList;
      listA.classList.add('honor-marquee-list');
      const listB = listA.cloneNode(true);
      listB.classList.add('honor-marquee-list', 'honor-marquee-clone');

      // Clear container and append track
      container.innerHTML = '';
      track.appendChild(listA);
      track.appendChild(listB);
      container.appendChild(track);

      // configuration: speed in px/s and minimum duration
      const speed = 60; // px per second; adjust to taste
      const minDuration = 4; // seconds

      let rafId = null;

      const recalcCardWidth = () => {
        const style = getComputedStyle(listA);
        let columns = parseFloat(style.getPropertyValue('--columns')) || 6;
        columns = Math.max(1, Math.round(columns));
        let gapStr = style.getPropertyValue('--column-gap') || getComputedStyle(document.documentElement).getPropertyValue('--column-gap') || '24px';
        const gap = parseFloat(gapStr) || 24;
        const containerW = container.getBoundingClientRect().width;
        const cardWidth = Math.max(40, (containerW - (columns - 1) * gap) / columns);
        const setCard = (card) => {
          card.style.flex = `0 0 ${cardWidth}px`;
          card.style.width = `${cardWidth}px`;
          card.style.boxSizing = 'border-box';
        };
        const cardsA = listA.querySelectorAll('.honor-list-v3__card');
        cardsA.forEach(setCard);
        const cardsB = listB.querySelectorAll('.honor-list-v3__card');
        cardsB.forEach(setCard);
      };

      const calculateDuration = () => {
        // make sure card widths are set based on current container width & columns
        recalcCardWidth();
        const w = listA.getBoundingClientRect().width;
        const duration = Math.max(minDuration, w / speed);
        track.style.setProperty('--honor-marquee-duration', `${duration}s`);
        track.style.animation = `honor-marquee var(--honor-marquee-duration) linear infinite`;
        track.style.animationPlayState = 'running';
      };

      // Wait until content width is measurable (images may still load)
      const waitForReady = () => {
        const w = listA.getBoundingClientRect().width;
        if (w > 0) {
          calculateDuration();
          return;
        }
        const imgs = listA.querySelectorAll('img');
        const pending = Array.from(imgs).filter(i => !i.complete);
        if (pending.length === 0) {
          // try again next frame
          requestAnimationFrame(() => calculateDuration());
        } else {
          let loaded = 0;
          pending.forEach(img => img.addEventListener('load', () => {
            loaded++;
            if (loaded === pending.length) calculateDuration();
          }));
          // fallback if images don't fire load
          setTimeout(() => calculateDuration(), 700);
        }
      };

      waitForReady();

      const resizeHandler = () => calculateDuration();
      window.addEventListener('resize', resizeHandler);

      // Utils to read current translateX (supports matrix & matrix3d)
      const getComputedTranslateX = (el) => {
        const st = window.getComputedStyle(el);
        const tr = st.transform || st.webkitTransform;
        if (tr && tr !== 'none') {
          let match = tr.match(/matrix\((.+)\)/);
          if (match) {
            const values = match[1].split(', ');
            return parseFloat(values[4]);
          }
          match = tr.match(/matrix3d\((.+)\)/);
          if (match) {
            const values = match[1].split(', ');
            return parseFloat(values[12]);
          }
        }
        return 0;
      };

      // Drag handling (pointer events + rAF for smoothness)
      let isDown = false;
      let startX = 0;
      let lastTranslate = 0;
      let desiredTranslate = 0;
      let moveRaf = null;

      const pointerDown = (e) => {
        // only primary button
        if (e.button && e.button !== 0) return;
        isDown = true;
        e.preventDefault();
        startX = e.clientX;
        track.style.animationPlayState = 'paused';
        lastTranslate = getComputedTranslateX(track);
        if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
      };

      const pointerMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const dx = e.clientX - startX;
        desiredTranslate = lastTranslate + dx;
        if (moveRaf) cancelAnimationFrame(moveRaf);
        moveRaf = requestAnimationFrame(() => {
          track.style.transform = `translateX(${desiredTranslate}px)`;
          moveRaf = null;
        });
      };

      const resumeAnimation = () => {
        const w = listA.getBoundingClientRect().width;
        // read inline transform if applied
        let x = getComputedTranslateX(track);
        const inline = track.style.transform;
        if (inline && inline.indexOf('translateX') >= 0) {
          const m = inline.match(/translateX\((-?\d+(?:\.\d+)?)px\)/);
          if (m) x = parseFloat(m[1]);
        }

        // normalize progress and compute elapsed seconds
        const progress = (((-x % w) + w) % w) / w; // 0..1
        const duration = parseFloat(getComputedStyle(track).getPropertyValue('--honor-marquee-duration')) || Math.max(minDuration, w / speed);
        const elapsed = progress * duration;

        // clear transform and restart CSS animation at the correct offset
        track.style.transform = '';
        // force reflow
        // eslint-disable-next-line no-unused-expressions
        track.offsetWidth;
        track.style.animation = `honor-marquee var(--honor-marquee-duration) linear infinite`;
        track.style.animationDelay = `${-elapsed}s`;
        track.style.animationPlayState = 'running';
      };

      const pointerUp = (e) => {
        if (!isDown) return;
        isDown = false;
        try { if (e.pointerId && track.releasePointerCapture) track.releasePointerCapture(e.pointerId); } catch (err) {}
        if (moveRaf) { cancelAnimationFrame(moveRaf); moveRaf = null; }
        resumeAnimation();
      };

      const pointerCancel = (e) => {
        if (!isDown) return;
        isDown = false;
        if (moveRaf) { cancelAnimationFrame(moveRaf); moveRaf = null; }
        try { if (e.pointerId && track.releasePointerCapture) track.releasePointerCapture(e.pointerId); } catch (err) {}
        resumeAnimation();
      };

      track.addEventListener('pointerdown', pointerDown);
      track.addEventListener('pointermove', pointerMove);
      track.addEventListener('pointerup', pointerUp);
      track.addEventListener('pointerleave', pointerUp);
      track.addEventListener('pointercancel', pointerCancel);

      // store for cleanup
      this._marquee = {
        track,
        listA,
        listB,
        resizeHandler,
        pointerDown,
        pointerMove,
        pointerUp,
        pointerCancel,
      };
    }

    destroySwiper() {
      if (this.mySwiper) {
        try { this.mySwiper.destroy(); } catch (e) {}
        this.mySwiper = null;
      }

      if (this._marquee) {
        const { track, resizeHandler, pointerDown, pointerMove, pointerUp, pointerCancel } = this._marquee;
        window.removeEventListener('resize', resizeHandler);
        track.removeEventListener('pointerdown', pointerDown);
        track.removeEventListener('pointermove', pointerMove);
        track.removeEventListener('pointerup', pointerUp);
        track.removeEventListener('pointerleave', pointerUp);
        track.removeEventListener('pointercancel', pointerCancel);
        this._marquee = null;
      }
    }

    connectedCallback() { }
  }

  customElements.define('honor-list-v3', WhyChoose);
}